import { OrderSide } from '@/gen/publicApi'

import { FixSpecSides } from '@/utils/fix'

interface Props {
    side?: OrderSide | FixSpecSides
}

export default function OrderSideText({ side }: Props) {
    if (!side) {
        return null
    }
    if (side.toLowerCase() === 'buy') {
        return <span className="text-success">Buy</span>
    } else if (side.toLowerCase() === 'sell') {
        return <span className="text-destructive">Sell</span>
    }

    // There are other sides in the fix spec. If we get here then just output
    // the text (formatted without underscores and the first word capitalised)
    return <span className="capitalize text-muted">{side.replace(/_/g, ' ')}</span>
}
